import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SEND_AS_SMS: "Send som SMS",
      YOUR_FRIEND_PHONE_NUMBER: "Din venns mobilnummer",
      SEND_SMS: "Send SMS",
      OR_SHARE_THE_DICOUNT_VIA: "Eller del rabatten via",
      INVITATION_SHARED: "Invitasjon delt!",
      SHARE_ON_FACEBOOK_ERROR:
        "Oops! Kunne ikke dele rabattkoden på Facebook Messenger, vennligst forsøk igjen senere!",

      PHONE_NUMBER_DIGITS: 8,
      COPY_LINK: "Kopiér link",
      SHARE_LINK: "Del link",
      LINK_COPIED: "Linken er kopiert!",
      SHOW_THE_FULL_TEXT: "Vis hele meldingen",
      SHOW_LESS: "Vis mindre",
    },
    se: {
      SEND_AS_SMS: "Skicka som sms",
      YOUR_FRIEND_PHONE_NUMBER: "Din väns telefonnummer",
      SEND_SMS: "Skicka SMS",
      OR_SHARE_THE_DICOUNT_VIA: "Eller dela rabatten via",
      INVITATION_SHARED: "Inbjudan delad!",
      SHARE_ON_FACEBOOK_ERROR:
        "Det gick inte att dela rabattkoden på Facebook Messenger, försök igen senare!",

      PHONE_NUMBER_DIGITS: 10,
      COPY_LINK: "Kopiera länk",
      SHARE_LINK: "Dela länk",
      LINK_COPIED: "Länk kopierad!",
      SHOW_THE_FULL_TEXT: "Visa hela sms:et",
      SHOW_LESS: "Visa mindre",
    },
    dk: {
      SEND_AS_SMS: "Send anbefaling på SMS",
      SEND_SMS: "Send SMS",
      YOUR_FRIEND_PHONE_NUMBER: "Din vens mobilnummer",
      SHOW_LESS: "Vis mindre",
      OR_SHARE_THE_DICOUNT_VIA: "Du kan også dele rabatten via",
      INVITATION_SHARED: "Anbefaling sendt!",
      SHARE_ON_FACEBOOK_ERROR:
        "Oops! Kunne ikke dele rabatkoden på Facebook Messenger, venligst prøv igen senere!",

      PHONE_NUMBER_DIGITS: 8,
      COPY_LINK: "Kopiér link",
      SHARE_LINK: "Del link",
      LINK_COPIED: "Linket er kopieret!",
      SHOW_THE_FULL_TEXT: "Vis hele beskeden",
    },
  } as const
)[language];
